
export class MakeModel {
  id: number;
  displayName: string;
  active: boolean;

  constructor() {
    this.id = null;
    this.displayName = null;
    this.active = null;
  }
}
